export const INLINE_EDIT = "__inEdit"
export const SELECTED = "__selected"
export const SHOULD_SHOW = "__shouldShow"

export const InternalProperties = {
    INLINE_EDIT,
    SELECTED,
    SHOULD_SHOW,
}